export default "__VITE_ASSET__CKIKzBOF__"